import { CustomValidators } from "@utils/validators";

export const HandleRouterError = (err: string | Indexable | unknown): void => {
  if (err && CustomValidators.isObject(err) && (err as Indexable).name === "NavigationDuplicated") {
    console.warn(err);
  } else throw err;
};
